


<form  [formGroup] = "flagsForm">

  <div id="gasModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Enter the name of the gas utility:</p>
      <input id="gasInput" style="margin-bottom: 2em;"/>
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleGasResponse(true)">Save</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleGasResponse(false)">Cancel</button>
    </div>
  </div>
  
  <div id="elecModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 300px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">Enter the name of the electric utility:</p>
      <input id="elecInput" style="margin-bottom: 2em;" />
      <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleElecResponse(true)">Save</button>
      <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleElecResponse(false)">Cancel</button>
    </div>
  </div>


  <div>
  <div style="padding-top: 2em;">

    <p style="line-height: 0.5em;
    font-size: 20px;
    letter-spacing: 1px;
    color: #3f3f3f;">{{subdivision_name || 'No Subdivision'}}-{{lot}}</p>
    <p style="font-size: 16px;
    line-height: 0.5em;
    letter-spacing: 0.5px;
    font-weight: 700;
    color: #8f8f8f;">{{street_address}}</p>


  </div>

  <div style="overflow-y: scroll;">
    <h3 style="color: #3f3f3f;padding-top: 0.5em; font-size: 1.5em;">Ekotrope</h3>

    <div style="padding-top: 0.5em; ">

      
      <div style="display: flex; flex-direction: row;">
        <div style="padding:0.5em;">
            <mat-form-field style="width:25%">
              <mat-label>Ekotrope ID: </mat-label>
              <input matInput #ekoInput formControlName = "ekotrope_id">
            </mat-form-field>
            <button *ngIf="ekoInput.value" mat-button [ngStyle]="{'color': hasRegistryId ? '#2e7d32' : '#c62828'}"
                    [matTooltip]="hasRegistryId ? 'Registry ID present' : 'No Registry ID yet - re-import after you register in Ekotrope'"
                    (click)="ekoImport(ekoInput.value)">Import <fa-icon [icon]="faImport"></fa-icon></button>
            <button *ngIf="ekoInput.value" mat-button color="primary" [disabled]="qaReviewLoading" (click)="qaReview()">{{ qaReviewLoading ? 'Checking...' : 'QA Review' }} <fa-icon [icon]="faQaReview"></fa-icon></button>
            <a *ngIf="ekoInput.value" [href]='getEkotropeLink(ekoInput.value)' target="_blank" style="color: black;">View Ekotrope Project</a>

          <div fxLayout="row" fxLayout.xs = "column">
            <div matRipple [matRippleDisabled]="true" #regripple>
                  <mat-form-field style="width:70%; margin-top: 20px;">
                    <mat-label>Registry ID:</mat-label>
                    <input matInput formControlName = "registryid">
                  </mat-form-field>
            </div>

            <div matRipple [matRippleDisabled]="true" #ripple>
                  <mat-form-field style="width:70%; margin-top: 20px;">
                      <mat-label>HERS index:</mat-label>
                      <input matInput formControlName = "hers_index">
                  </mat-form-field>
            </div>
          </div>
        </div>

        <div style="padding: 1em;width: 50%;">
          <mat-form-field style="width:100%">
            <mat-label>Admin Notes:</mat-label>
            <textarea matInput formControlName = "adminnotes" style="height: 100px;"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div style="padding: 0 0.5em;">
        <button mat-button type="button" (click)="showQaReview = !showQaReview">{{ showQaReview ? 'Hide' : 'Show' }} QA Review Notes</button>
        <div *ngIf="showQaReview"
             style="white-space: pre-wrap; background:#ffffff; border:1px solid #d0d0d0; border-radius:4px; padding:0.75em; margin-top:0.5em; max-height:220px; overflow-y:auto; font-size:0.9em; color:#424242;">{{ qaReviewNote || 'No QA review has been run on this location yet.' }}</div>
      </div>

    </div>

  <div style="height:98%;overflow-y:auto;">
      <h3 style="color: #3f3f3f;font-size: 1.5em;">Check applicable items</h3>
      <div style="display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;">

        <div class = "formitem-section" style="padding: 0.25em;">
          <mat-label style="white-space: nowrap;
          font-size: 20px;
          color: #3f3f3f;
          letter-spacing: -0.5px;">Disclosure Sent?  </mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "disclosuresent"></mat-checkbox>
        </div>

        <div class = "formitem-section" style="padding: 0.25em;">
            <mat-label style="white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">County Form Sent?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "cfsent"></mat-checkbox>
          </div>

        <div class = "formitem-section" style="padding: 0.25em;">
          <mat-label style="white-space: nowrap;
          font-size: 20px;
          color: #3f3f3f;
          letter-spacing: -0.5px;">Cert Printed?  </mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "cert_printed" (change)="certPrintedDateUpdate()"></mat-checkbox>
        </div>

        <div class = "formitem-section" style="padding: 0.25em;">
          <mat-label style="white-space: nowrap;
          font-size: 20px;
          color: #3f3f3f;
          letter-spacing: -0.5px;">ESMFNC Data Needed?</mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;"  formControlName = "esmfnc"></mat-checkbox>
        </div>

        <div class = "formitem-section" style="padding: 0.25em;">
          <mat-label style="white-space: nowrap;
          font-size: 20px;
          color: #3f3f3f;
          letter-spacing: -0.5px;">Rem File Done?</mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;"  formControlName = "rem_done"></mat-checkbox>
        </div>
     
          <div class = "formitem-section" style="padding: 0.25em;">
            <mat-label style="white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Tax Credit?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "taxcred"></mat-checkbox>
          </div>
      
          <div class = "formitem-section" style="padding: 0.25em;">
            <mat-label style="white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Archive This?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "adminarchive"></mat-checkbox>
            </div>
      
            <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Final Notice?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "finalnotice"></mat-checkbox>
              </div>
      
          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Final Report?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "finalreport"></mat-checkbox>
              </div>
      
          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Rough Notice?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "roughnotice"></mat-checkbox>
              </div>
      
          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Rough Report?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "roughreport"></mat-checkbox>
              </div>
      
              <div class = "formitem-section" style="padding: 0.25em;">
                <mat-label style="white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;">Hvac Paperwork Override?  </mat-label>
                <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "hvacovrd"></mat-checkbox>
                </div>
      
            <div class = "formitem-section" style="padding: 0.25em;">
            <mat-label style="white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Missing Info?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "missinginfo" (change)="missingInfoUpdate()"></mat-checkbox>
            </div>


            <div class = "formitem-section" style="padding: 0.25em;">
            <mat-label style="white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Targets Set?</mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "targetset"></mat-checkbox>
            </div>


          <div class="formitem-section" style="padding: 0.25em;">
          <mat-label style="
            white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">
            HVAC Design Report Request?</mat-label>
          <mat-checkbox
            style="padding-left: 5px; padding-right: 7px;"
            formControlName="hvac_dr_request"></mat-checkbox>
          </div>

      </div>




      </div>
      
      <div>
        <h3 style="color: #3f3f3f;font-size: 1.5em;">HVAC Grading</h3>

          <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center;">
            <div style="padding-right: 2em;">
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> 310 Report</mat-label>
                <mat-select  formControlName = "threetenrep">
                  <mat-option value = "Requested">Requested</mat-option>
                  <mat-option value = "Received">Received</mat-option>
                  <mat-option value = "Approved">Approved</mat-option>
                  <mat-option value = "Rejected">Rejected</mat-option>
                  <mat-option value = ""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> Refrigerant PW</mat-label>
                <mat-select  formControlName = "refrigpw">
                  <mat-option value = "Requested">Requested</mat-option>
                  <mat-option value = "Received">Received</mat-option>
                  <mat-option value = "Approved">Approved</mat-option>
                  <mat-option value = "Rejected">Rejected</mat-option>
                  <mat-option value = "Ineligible">Ineligible</mat-option>
                  <mat-option value = ""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </div>

      </div>

      <h3 style="color: #3f3f3f;font-size: 1.5em;">Rebates</h3>

      <div style="display:flex; flex-direction: column;">
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 1em; border: 1px solid #ccc; max-width: 600px;">
          <!-- Gas Box -->
          <div style="border: 1px solid #ddd; padding: 0.5em; border-radius: 8px; background-color: #f9f9f9;">
              <h3 style="margin: 0 0 10px;">Gas Rebate</h3>
              <!-- Add form controls here -->
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> Rebate </mat-label>
                  <mat-select class="my-special-select" formControlName = "gasrebate" (selectionChange)="updateRebateObj('gas','gasrebate',$event.value)">
                    <mat-option *ngFor="let rebate of gasrebates" [value]="rebate.rebate">{{rebate.rebate}}</mat-option>
                    <mat-option (onSelectionChange)="openGasRebateModal($event)">(Add New Option)</mat-option>
                  </mat-select>
              </mat-form-field>

              <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;">Rebate 1  </mat-label>
                <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "gas_rebate1" (change)="updateRebateObj('gas','gas_rebate1',$event.checked)"></mat-checkbox>
              </div>

              <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;">Rebate 2  </mat-label>
                <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "gas_rebate2" (change)="updateRebateObj('gas','gas_rebate2',$event.checked)"></mat-checkbox>
              </div>

              <div>
                <mat-form-field style="margin-top: 15px;">
                  <mat-label style=" white-space: nowrap;
                  font-size: 20px;
                  color: #3f3f3f;
                  letter-spacing: -0.5px;"> Rebate 2 Status</mat-label>
                  <mat-select  formControlName = "gas_rebate_2_status" (selectionChange)="updateRebateObj('gas','gas_rebate_2_status',$event.value)">
                    <mat-option value = "Pass">Pass</mat-option>
                    <mat-option value = "Fail">Fail</mat-option>
                    <mat-option value = "Forgo">Forgo</mat-option>
                    <mat-option value = "Not Eligible">Not Eligible</mat-option>
                    <mat-option value = ""></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

               
              <!-- <input type="text" placeholder="Enter Gas Value" style="width: 100%; padding: 8px; margin-top: 5px; border: 1px solid #ccc; border-radius: 4px;"> -->
          </div>
  
          <!-- Electric Box -->
          <div style="border: 1px solid #ddd; padding: 0.5em; border-radius: 8px; background-color: #f9f9f9;">
              <h3 style="margin: 0 0 10px;">Electric Rebate</h3>
              <!-- Add form controls here -->
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> Rebate </mat-label>
                <mat-select  class="my-special-select" formControlName = "elecrebate" (selectionChange)="updateRebateObj('electric','elecrebate',$event.value); selectionChangeRebate($event.value);">
                  <mat-option *ngFor="let rebate of elecrebates" [value]="rebate.rebate">{{rebate.rebate}}</mat-option>
                  <mat-option (onSelectionChange)="openElecRebateModal($event)">(Add New Option)</mat-option>
                </mat-select>
              </mat-form-field>

              <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;">Rebate 1  </mat-label>
                <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "electric_rebate1" (change)="updateRebateObj('electric','electric_rebate1',$event.checked)"></mat-checkbox>
              </div>

              <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;">Rebate 2  </mat-label>
                <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "electric_rebate2" (change)="updateRebateObj('electric','electric_rebate2',$event.checked)"></mat-checkbox>
              </div>

              <div>
                <mat-form-field style="margin-top: 15px;">
                  <mat-label style=" white-space: nowrap;
                  font-size: 20px;
                  color: #3f3f3f;
                  letter-spacing: -0.5px;"> Rebate 2 Status</mat-label>
                  <mat-select  formControlName = "electric_rebate_2_status" (selectionChange)="updateRebateObj('electric','electric_rebate_2_status',$event.value)">
                    <mat-option value = "Pass">Pass</mat-option>
                    <mat-option value = "Fail">Fail</mat-option>
                    <mat-option value = "Forgo">Forgo</mat-option>
                    <mat-option value = "Not Eligible">Not Eligible</mat-option>
                    <mat-option value = ""></mat-option>

                  </mat-select>
                </mat-form-field>
              </div>

              <div *ngIf="tiers.length > 0">
                <mat-form-field style="margin-top: 15px;">
                  <mat-label style=" white-space: nowrap;
                  font-size: 20px;
                  color: #3f3f3f;
                  letter-spacing: -0.5px;">Tier</mat-label>
                  <mat-select  formControlName = "electric_tier" (selectionChange)="updateRebateObj('electric','electric_tier',$event.value)">
                      <mat-option *ngFor="let tier of tiers" [value]="tier">{{tier}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>



          </div>
      </div>

      <!--
      <div style="display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;">

      
        <div class = "formitem-section" style="padding: 1em;" title="Hero Initial Registration">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Rebate 1?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "rebate1"></mat-checkbox>
          </div>


        <div class = "formitem-section" style="padding: 1em;" title="Hero Final Submission">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Rebate 2?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "rebate2"></mat-checkbox>
            </div>

            <div class = "formitem-section" style="padding: 1em;" title="Gas Rebate">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Rebate 3?  </mat-label>
              <mat-checkbox style="padding-left: 5px; padding-right: 7px;" (change)="updateRebate3()" formControlName = "rebate3"></mat-checkbox>
            </div>


            <mat-form-field style="margin-top: 15px; width:33%;">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;"> Rebate 2 Status </mat-label>
              <mat-select  formControlName = "rebate2stat">

                <mat-option value = "Pass HERO">Pass HERO</mat-option>
                <mat-option value = "Failed HERO/Canceled">Failed HERO/Canceled</mat-option>
                <mat-option value = "Forgo HERO/Canceled">Forgo HERO/Canceled</mat-option>
                <mat-option value = "Not in HERO territory/Canceled">Not in HERO territory/Canceled</mat-option>

              </mat-select>
            </mat-form-field>


      </div>
-->


      </div>


  </div>


    <div style="padding-top: 2em; ">
    <button style="padding-right: 40px;" class="menuChild" mat-button (click)="onNoClick()">Close</button>
    <button style="background: #8cc63f;
    color: white;
    width: 100px;
    height: 40px;" class="menuChild" mat-button (click)="save()" [mat-dialog-close]="data" cdkFocusInitial>Save</button>
    </div>

</div>


</form>
